"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanDetailsSummary = void 0;
var date_fns_1 = require("date-fns");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../shared/core");
var components_1 = require("../../../../shared/core/components");
var copy_1 = require("../../copy");
var ExitFee_1 = require("../../pages/Plan/ui/components/ExitFee");
exports.PlanDetailsSummary = (0, react_1.forwardRef)(function (_a, ref) {
    var contract = _a.contract, rest = __rest(_a, ["contract"]);
    var _b = (0, core_1.useComponents)(), SummaryList = _b.SummaryList, SummaryItem = _b.SummaryItem, Pii = _b.Pii;
    var copy = (0, core_1.useCopy)(copy_1.defaultOptions).copy;
    var name = contract.name, contractType = contract.contractType, contractStartDate = contract.contractStartDate, contractEndDate = contract.contractEndDate, exitFee = contract.exitFee, projectedConsumption = contract.projectedConsumption, isInRenewal = contract.isInRenewal, hasFutureContracts = contract.hasFutureContracts;
    return (react_1.default.createElement(components_1.SimpleContentCard, __assign({}, rest, { ref: ref }),
        react_1.default.createElement(SummaryList, null,
            react_1.default.createElement(SummaryItem, { label: copy('contractNameLabel'), "data-testid": "plan-name" }, name),
            react_1.default.createElement(SummaryItem, { label: copy('contractStartDateLabel'), "data-testid": "contract-start" }, (0, date_fns_1.format)(contractStartDate, 'd MMM yyyy')),
            react_1.default.createElement(SummaryItem, { label: copy('contractEndDateLabel'), "data-testid": "contract-end" }, contractEndDate != null
                ? (0, date_fns_1.format)(contractEndDate, 'd MMM yyyy')
                : copy('variableContractEndDate')),
            react_1.default.createElement(SummaryItem, { label: copy('exitFeeLabel'), "data-testid": "exit-fee" },
                react_1.default.createElement(ExitFee_1.ExitFee, { contractType: contractType, exitFee: exitFee, isInRenewal: isInRenewal, hasFutureContracts: hasFutureContracts, contractEndDate: contractEndDate })),
            projectedConsumption.map(function (item, index) { return (react_1.default.createElement(SummaryItem, { key: "projected-consumption-".concat(index), label: copy('projectedAnnualConsumptionLabel'), "data-testid": "projected-consumption" },
                react_1.default.createElement(Pii, null, copy('projectedAnnualConsumption', {
                    annualConsumption: Number(item.consumption).toFixed(0),
                })))); }))));
});
